import { Tabs } from "antd";
import React, { useEffect, useState , useRef } from "react";
import "../css/purchase.css";
import Scandata from "./scandata";
import Masterpatient from "./masterpatient";
import Masterdoctor from "./masterdoctor";
import axios from "axios";
import { path, src } from "../network/conn";
const { TabPane } = Tabs;
const Scanentry = (Props) => {
  const [scanSetting,setScanSetting] = useState({});
  const [doctorSetting,setDoctorSetting] = useState({});
  const [patientSetting,setPatientSetting] = useState({});
  const handleDocPatRefresh = useRef();
  const handleScanDataEntered = () =>{
    
    console.log('loged');
    Props.onScanDataRefresh();
    console.log('logedOut');
  }
  const handleScanDoctorRefresh = () =>{
    handleDocPatRefresh.current.handlePropsReload();
  }
  const handleScanPatientRefresh = () =>{
    handleDocPatRefresh.current.handlePropsReload();
  }
  const profile = window.sessionStorage.getItem("profile");
 const fetch_profile_permission = (profile) =>{
   console.log('profile',profile);
   let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
   axios
   .get(BaseURL)
     .then((response) => {
       console.log(response.data);
       let dataObj = {};
       response.data.map((list)=>{
         let permissionObj = {};
         if(list.filename == 'masterdoctor'){
         permissionObj['show']     = list.show;
         setDoctorSetting(permissionObj);
         } if(list.filename == 'masterpatient'){
          permissionObj['show']     = list.show;
          permissionObj['print']    = list.print;
          setPatientSetting(permissionObj);
          } if(list.filename == 'scanentry'){
            permissionObj['show']     = list.show;;
            setScanSetting(permissionObj);
            }
       })
     })
     .catch((error) => {
       //openMessageSuccess(error, 10);
       console.log(error);
     });
   }
  useEffect(() => {
   fetch_profile_permission(profile);
  }, []);
  return (
    <Tabs defaultActiveKey="1">
      {Number(doctorSetting.show)== 1 ?
      <TabPane tab="Doctor" key="1">
      <Masterdoctor onScanDataReload = {handleScanDoctorRefresh} permission = {doctorSetting}/> </TabPane>  : ''}  
      {Number(patientSetting.show)== 1 ?    
      <TabPane tab="Patient Entry" key="2">
        <Masterpatient onScanDataPatiReload = {handleScanPatientRefresh} permission = {patientSetting}/>
      </TabPane> : ''}  
       {Number(scanSetting.show)== 1 ?
      <TabPane tab="Scan Entry" key="3">
      <Scandata onScanDataEntered = {handleScanDataEntered}  ref={handleDocPatRefresh} permission = {scanSetting}/>
      </TabPane> : ''}  
    </Tabs>
  );
};
export default Scanentry;
